<div class="result-wrapper">
  <div class="container-generic result-card text-center">
	<h2 class="form-title mb-3">Conferma email</h2>

	@if (isLoading()) {
	  <div class="d-flex flex-column align-items-center gap-3">
		<div class="spinner-border text-primary" role="status" aria-label="Verifica in corso"></div>
		<p class="generic-text mb-0">Verifica in corso...</p>
	  </div>
	} @else if (isSuccess()) {
	  <div class="alert alert-success" role="alert">
		{{ message() }}
	  </div>
	  <p class="generic-text">Sarai reindirizzato al login tra pochi secondi.</p>
	  <a class="btn btn-primary d-inline-flex align-items-center gap-1" routerLink="/login">
	    <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>Vai al login
	  </a>
	} @else {
	  <div class="alert alert-danger" role="alert">
		{{ message() }}
	  </div>
	  <div class="d-flex flex-column flex-sm-row gap-2 justify-content-center">
		<button class="btn btn-outline-primary d-inline-flex align-items-center gap-1 justify-content-center" type="button" (click)="retryVerification()">
		  <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Riprova
		</button>
		<a class="btn btn-warning d-inline-flex align-items-center gap-1 justify-content-center" routerLink="/signup">
		  <i class="bi bi-person-plus" aria-hidden="true"></i>Nuova registrazione
		</a>
	  </div>
	}
  </div>
</div>
